import React from "react";

// lazily import the large mermaid renderer package
const MermaidRenderer = React.lazy(() => import("./MermaidRenderer"));

export const Mermaid = (props: any) => <MermaidRenderer {...props} />;
